import { formatNumber } from '@/lib/format'

/* The pure helpers the Money section owns: how a variance is toned, and how a
 * delta is written so it does not read as an amount. Nothing here touches React
 * or the wire, which is what makes the section's arithmetic readable in one
 * screen instead of scattered through the markup. */

/** `null` closed, `'new'` adding, a record editing — see DirectoriesPage. */
export type EditTarget<T> = T | 'new' | null

export function editing<T>(target: EditTarget<T>): T | undefined {
  return target === null || target === 'new' ? undefined : target
}

/** Sign decides tone (AD-9 — the NUMBER is served): over plan argues in red,
 *  under plan relaxes in green, on plan stays quiet. */
export function varianceTone(amount: string): string {
  const over = Number(amount)
  return over > 0 ? 'text-negative font-semibold' : over < 0 ? 'text-positive' : 'text-text-muted'
}

/** `+640.00` — an explicit plus, because a bare variance figure in a money
 *  table reads as an amount, not a delta. Minus arrives from formatNumber. */
export function signedNumber(amount: string): string {
  return Number(amount) > 0 ? `+${formatNumber(amount, 2)}` : formatNumber(amount, 2)
}
